var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaultEmptyStateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 64,
    viewBox: "0 0 161 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.4531 16.375L80.3731 10.4688L107.756 16.375L80.3731 24.0669L52.4531 16.375Z",
    fill: "#F1F3F5",
    stroke: "#ACB1BB",
    strokeWidth: 0.858238,
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4531 16.3721L80.3731 10.4659L80.3731 24.064L52.4531 16.3721Z",
    fill: "#DDE3EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4531 16.3721L80.3731 10.4659L107.756 16.3721L80.3731 24.064L52.4531 16.3721Z",
    stroke: "#ACB1BB",
    strokeWidth: 0.858238,
    strokeLinejoin: "bevel"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.918 16.9136L80.9119 24.2158V53.4245L51.918 44.036V16.9136Z",
    fill: "white",
    stroke: "#ACB1BB",
    strokeWidth: 0.858238,
    strokeLinejoin: "bevel"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.757 16.9136L80.9106 24.2158V53.4245L107.757 44.036V16.9136Z",
    fill: "white",
    stroke: "#ACB1BB",
    strokeWidth: 0.858238,
    strokeLinejoin: "bevel"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.323 16.3066L80.627 24.151L87.0341 33.9618L113.73 24.0989L107.323 16.3066Z",
    fill: "white",
    stroke: "#ACB1BB",
    strokeWidth: 0.858238,
    strokeLinejoin: "bevel"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4877 16.3066L79.836 24.2159L73.3929 34.3561L46.0098 24.2161L52.4877 16.3066Z",
    fill: "white",
    stroke: "#ACB1BB",
    strokeWidth: 0.858238,
    strokeLinejoin: "bevel"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8176 41.7974C16.2605 39.8141 21.033 36.2134 26.7342 35.1867L30.5307 34.5031L46.1618 41.642L38.5758 43.0081C35.3629 43.5866 32.3567 44.9936 29.8542 47.0899L26.8534 49.6038C26.8534 49.6038 8.94769 42.4788 10.8176 41.7974Z",
    fill: "white",
    stroke: "#ACB1BB",
    strokeWidth: 0.858238,
    strokeLinejoin: "bevel"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.665 38.5386L34.1891 41.2184",
    stroke: "#ACB1BB",
    strokeWidth: 0.858238,
    strokeLinejoin: "bevel"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9248 39.8989L30.4489 42.5787",
    stroke: "#ACB1BB",
    strokeWidth: 0.858238,
    strokeLinejoin: "bevel"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9248 42.3303L26.4489 45.0101",
    stroke: "#ACB1BB",
    strokeWidth: 0.858238,
    strokeLinejoin: "bevel"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M133.03 47.3071C132.553 47.1947 132.058 46.8463 131.571 46.3597C128.239 43.0303 125.365 39.0838 121.059 37.1759L116.154 35.0031L100.397 39.7225L107.166 43.4833C109.255 44.6436 111.102 46.1921 112.61 48.0458L116.154 52.4039C116.154 52.4039 135.444 47.875 133.03 47.3071Z",
    fill: "white",
    stroke: "#ACB1BB",
    strokeWidth: 0.858238,
    strokeLinejoin: "bevel"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M113.981 40.3066L108.672 42.0222",
    stroke: "#ACB1BB",
    strokeWidth: 0.858238,
    strokeLinejoin: "bevel"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M118.604 43.0356L113.638 44.6908",
    stroke: "#ACB1BB",
    strokeWidth: 0.858238,
    strokeLinejoin: "bevel"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M121.913 47.4495L117.499 48.6434",
    stroke: "#ACB1BB",
    strokeWidth: 0.858238,
    strokeLinejoin: "bevel"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M124.118 30.232C124.118 30.232 129.039 30.5475 131.384 34.2871",
    stroke: "#ACB1BB",
    strokeWidth: 0.858238,
    strokeLinejoin: "bevel"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M116.394 32.7645C116.394 32.7645 118.049 32.3254 119.153 33.9809",
    stroke: "#ACB1BB",
    strokeWidth: 0.858238,
    strokeLinejoin: "bevel"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0659 27.8865C33.0659 27.8865 35.2185 26.8237 37.9891 26.676",
    stroke: "#ACB1BB",
    strokeWidth: 0.858238,
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultEmptyStateIcon);
export default __webpack_public_path__ + "static/media/vault-empty-state-icon.ee95c051122511d31d18889b8bf41edb.svg";
export { ForwardRef as ReactComponent };